// PRE-ROLL (3-2-1 countdown) markup — verbatim from the prototype.
export const prerollHTML = /* html */ `
<div id="screenPreroll" class="preroll hidden">
  <div class="qn" id="prerollQ">Question 1 of 10</div>
  <div class="cat" id="prerollCat"></div>
  <div class="count-wrap" id="prerollWrap">
    <svg class="count-ring" viewBox="0 0 120 120">
      <circle class="ring-bg" cx="60" cy="60" r="54"/>
      <circle class="ring-fg" cx="60" cy="60" r="54"/>
    </svg>
    <span class="count-pulse"></span>
    <div class="count" id="prerollCount">3</div>
  </div>
</div>`;
